(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory((function webpackLoadOptionalExternalModule() { try { return require("mapbox-gl-js"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["mapbox-gl-js"], factory);
	else if(typeof exports === 'object')
		exports["tomtom"] = factory((function webpackLoadOptionalExternalModule() { try { return require("mapbox-gl-js"); } catch(e) {} }()));
	else
		root["tomtom"] = factory(root["mapbox-gl-js"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_118__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition